import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow, { tableRowClasses } from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Checkbox from "@mui/material/Checkbox";
import { visuallyHidden } from "@mui/utils";
import { ReactComponent as SortIcon} from '../../../assets/images/uparrow.svg'
import styled from "@emotion/styled";
import {ReactComponent as EmailIcon} from '../../../assets/images/email2.svg'
import {ReactComponent as LoginIcon} from '../../../assets/images/login.svg'
import {ReactComponent as HAIcon} from '../../../assets/images/report-data.svg'
import {ReactComponent as PACIcon} from '../../../assets/images/pac.svg'
import {ReactComponent as QueryIcon} from '../../../assets/images/Query.svg'
import {ReactComponent as SessionIcon} from '../../../assets/images/session2.svg'
import {ReactComponent as PSCIcon} from '../../../assets/images/notes.svg'
import {ReactComponent as FeedbackIcon} from '../../../assets/images/feedback.svg'
import {ReactComponent as TestimonialIcon} from '../../../assets/images/testimonial.svg'
import {
  stableSort,
  getComparator,
  validateDate,
} from "../../../utils/helpers/universalFunctions";
import { Link, createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { STATUS_REPORT_ENDPOINT } from "../../../routes/route";
import { CircularProgress, TablePagination, tablePaginationClasses } from "@mui/material";
import { ReactComponent as arrowDownIcon} from '../../../assets/images/arrow-down-brown.svg'
import * as routes from '../../../routes/route'
import getPermissions from "../../../utils/helpers/getPermissions";
import moment from "moment";

const statusClasses=['fade', 'brown', 'green']

const healthAssessmentType={
  ARRIVAL: "HEALTH_ASSESSMENT_ARRIVAL", 
  INTERM: "HEALTH_ASSESSMENT_INTERIM", 
  DEPARTURE: "HEALTH_ASSESSMENT_DEPARTURE"
}

//Filter condition for Health assessment
//Arrival - A
//Interm - I
//Departure - D

// case 0: no filter selected []
//   Ring: One having data
//   Id: One having data

// case 1: one filter selected [A] / [I] / [D]
//   Ring: Respective ring
//   Id: Respective data

// case 2: one filter selected [A, I] / [I,D] / [A, D]
//   Ring: last type ring
//   Id: One having data

// case 3: all filter selected [A, I, D]
//   Ring: D
//   Id: One having data

const getHealthAssessmentRingKey =(data)=>{
  let {activityFilters, row} = data;
  let length = activityFilters?.length;

  switch(length){
      case 0: 
        if(row.assessment_departure?.toString()?.length>1)
          return 'assessment_departure'
        else if(row.assessment_interim?.toString()?.length>1)
          return 'assessment_interim'
        else
          return 'assessment_arrival'

      case 1:
        if(activityFilters.includes(healthAssessmentType.DEPARTURE))
          return 'assessment_departure'
        else if(activityFilters.includes(healthAssessmentType.INTERM))
          return 'assessment_interim'
        else
          return 'assessment_arrival'
      
      case 2:
        if(activityFilters.includes(healthAssessmentType.DEPARTURE))
          return 'assessment_departure'
        else 
          return 'assessment_interim'

      case 3:
        return 'assessment_departure'
    

    // key: ({activityFilters, row}) => (activityFilters.includes(healthAssessmentType.DEPARTURE) || !activityFilters.length) ? 
    //       "assessment_departure" :
    //         activityFilters.includes(healthAssessmentType.INTERM) ?
    //         "assessment_interim" 
    //         :
    //         "assessment_arrival"
    //     ,
  }
}

const getHealthAssessmentIDKey =(data)=>{
  let {activityFilters, row} = data;
  let length = activityFilters?.length;

  switch(length){
      case 0 || 3: 
        if(row.assessment_departure?.toString()?.length>1)
          return 'assessment_departure_id'
        else if(row.assessment_interim?.toString()?.length>1)
          return 'assessment_interim_id'
        else
          return 'assessment_arrival_id'

      case 1:
        if(activityFilters.includes(healthAssessmentType.DEPARTURE))
          return 'assessment_departure_id'
        else if(activityFilters.includes(healthAssessmentType.INTERM))
          return 'assessment_interim_id'
        else
          return 'assessment_arrival_id'
      
      case 2:
        if(activityFilters.includes(healthAssessmentType.DEPARTURE))
          if(row.assessment_departure?.toString()?.length>1)
            return 'assessment_departure_id'
          else if(activityFilters.includes(healthAssessmentType.INTERM))
            return 'assessment_interim_id'
          else
            return 'assessment_arrival_id'
        else 
          if(row.assessment_interim?.toString()?.length>1)
            return 'assessment_interim_id'
          else
            return 'assessment_arrival_id'
  }
}




const ITEMS = [
    {
        title: 'Email',
        image: <EmailIcon/>,
        key: (data) => "welcome_email_sent",
        hideToNonWellness: false,
        idKey: () => "",
        dataKey: ()=> "welcome_email_sent_datetime",
        path: routes.SEARCH_RESULT_ENDPOINT
    },
    {
        title: 'Login',
        image: <LoginIcon/>,
        key: (data) => "is_login",
        hideToNonWellness: false,
        idKey: () => "",
        dataKey: ()=> "last_login_datetime",
    },
    {
        title: 'Health Assessment',
        image: <HAIcon/>,
        key: (data) => getHealthAssessmentRingKey(data),
        hideToNonWellness: true,
        idKey: (data) => getHealthAssessmentIDKey(data),
        dataKey: (data)=> getHealthAssessmentRingKey(data),
        path: routes.VIEW_WELLBEING_REPORT_ENDPOINT,
        permissions: getPermissions("wellbeing_report"),
      },
      {
        title: 'PAC',
        image: <PACIcon/>,
        key: (data) => "is_pac_complete",
        hideToNonWellness: true,
        idKey: () => "",
        dataKey: ()=> "pac_datetime",
        path: routes.VIEW_PRELIM_ASSESMENT_ENDPOINT,
        permissions: getPermissions("prelim_assessment"),
    },
    {
        title: 'Data and Consultations',
        image: <PSCIcon/>,
        key: (data) => "is_notes_added",
        hideToNonWellness: true,
        idKey: () => "",
        path: routes.VIEW_CONSULTATION_NOTES_ENDPOINT,
        permissions: getPermissions("consultation_notes"),
    },
    {
        title: 'Query',
        image: <QueryIcon/>,
        key: (data) => "is_query_done",
        hideToNonWellness: true,
        idKey: () => "",
        dataKey: ()=> "query_status",
        path: routes.QUERY_ENDPOINT,
        permissions: getPermissions("wellbeing_queries"),
    },
    {
        title: 'Session Review',
        image: <SessionIcon/>,
        key: (data) => "session_review_filled",    //
        hideToNonWellness: false,
        idKey: () => "",
        dataKey: ()=> "session_review_filled_count",
        path: routes.VIEW_SESSION_ENDPOINT,
        permissions: getPermissions("session_module"),
    },
    {
      title: 'Program Feedback',
      image: <FeedbackIcon fill="#74613c"/>,
      key: (data) => "program_feedback",
      hideToNonWellness: false,
      idKey: () => "",
      dataKey: ()=> "program_feedback",
      path: routes.VIEW_PROGRAMME_FEEDBACK_ENDPOINT
    },
    {
      title: 'Testimonial',
      image: <TestimonialIcon fill="#74613c" />,
      key: (data) => "testimonial",
      hideToNonWellness: false,
      idKey: () => "",
      dataKey: ()=> "testimonial",
      path: routes.VIEW_TESTIMONIAL_ENDPOINT
    },
]


const TableRowStyled = styled(TableRow)`
     
  &:nth-of-type(odd) td {
    border: none;
    padding-bottom: 0;
  },

  &:nth-of-type(4n-1) td {
    border-top: 2.5px solid #DDDDDD;
    background-color: #F5F5F5;
  },

  &:nth-of-type(4n-0) td {
    border-bottom: 2.5px solid #DDDDDD;
    background-color: #F5F5F5;
  },

  &:nth-of-type(4n-1) td:first-of-type, &:nth-of-type(4n-0) td:first-of-type  {
    border-left: 2px solid #DDDDDD;
  },

  &:nth-of-type(4n-1) td:last-child, &:nth-of-type(4n-0) td:last-child  {
    border-right: 2px solid #DDDDDD;
  },
`;

const TableCellStyled = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: 550,
    fontFamily: 'Montserrat',
    zIndex: 0,
    color: "#AAAAAA",
    padding: '18px 8px 18px 5px',
    wordBreak: "break-word",
    fontSize: "13px",
    textTransform: 'uppercase',
    borderTop: "1px solid #DDDDDD"
  },
  

  [`&.${tableCellClasses.head}:first-of-type`]: {
    borderLeft: '0.5px solid #74613C',
    padding: '18px 8px 18px 15px',
  },

  [`&.${tableCellClasses.head}:last-child`]: {
    borderRight: '0.5px solid #74613C'
  },
  
  [`&.${tableCellClasses.body}`]: {
    fontSize: "14px",
    padding: '22px 8px 22px 9px',
    wordBreak: "break-word",
    fontSize: "14px",
  },

  [`&.${tableCellClasses.body}:first-of-type`]: {
    textTransform: 'capitalize',
    borderLeft: '0.5px solid #74613C',
    padding: '22px 8px 0px 15px',
  },
}));

const TablePaginationStyled = styled(TablePagination)(({ theme }) => ({
  fontSize: '14px',

  [`& .${tablePaginationClasses.select}`]: {
    padding: '4px 8px',
    borderRadius: '8px',
    backgroundColor: '#F5F3EC',
    border: '1px solid #DDDDDD'
  },

  [`& .${tablePaginationClasses.select}, & .${tablePaginationClasses.select}:focus`]: {
    borderRadius: '8px',
    border: '1px solid #DDDDDD'
  },

  [`& .${tablePaginationClasses.selectIcon}`]: {
    top: '12px',
    right: '7px',
    width: '9px'
  },

  [`& .${tablePaginationClasses.selectLabel}, &  .${tablePaginationClasses.displayedRows}`]: {
    margin: '0',
    fontSize: '14px'
  },

  [`& .${tablePaginationClasses.actions} button`]: {
    backgroundColor: '#F5F3EC',
    marginRight: '5px',
    padding: '3px 5px',
    border: '1px solid #DDDDDD'

  },

  [`& .${tablePaginationClasses.actions} svg`]: {
    width: '20px'
  },

}));

const StatusReportTable = ({
  loading,
  data,
  columns,
  checkbox = true,
  pagination = true,
  filter,

  //props are required if pagination is true
  totalCount,
  totalPages,
  start,
  end,
  currentPage,
  rowsPerPage,
  getTableData
}) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate();
  const [order, setOrder] = useState(filter.order);
  const [orderBy, setOrderBy] = useState(filter.orderBy);

  const [selected, setSelected] = useState([]);
  const [action, setAction] = useState('');
  const dispatch = useDispatch()
  const activityFilters = [...searchParams.entries()].filter(item=>item[0]==="category").map(item=>item[1])
  const notesFilters = [...searchParams.entries()].filter(item=>item[0]==="notesType").map(item=>item[1])


  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    let newOrder = isAsc ? "desc" : "asc";
    setOrder(newOrder);
    setOrderBy(property);
    
    searchParams.delete("order")
    searchParams.delete("orderBy")

      let newPair= [["order", newOrder], ["orderBy", property]];

      navigate({
        pathname: `${routes.STATUS_REPORT_ENDPOINT}`,
        search: `?${createSearchParams([...searchParams.entries(), ...newPair])}`,
      }, {replace: true})
  };

  const handleSelectAllClick = (event) => {
    const newSelected = event.target.checked ? data?.map((item) => ({subscriberId: item.subscriberId, flatId: item.flatId})) : [];
    setSelected(newSelected);
  };

  const handleClick = (event, id, flatId) => {
    const newSelected = selected.some(item => item.subscriberId === id && item.flatId === flatId)
      ? selected.filter((selectedItem) => !(selectedItem.subscriberId === id && selectedItem.flatId === flatId))
      : [...selected, {subscriberId: id, flatId}];
    setSelected(newSelected);
  };

  const handleChangePage = (e, newPage) => {
    window.scrollTo(0, 0)
      searchParams.delete("page")
      navigate({
        pathname: `${STATUS_REPORT_ENDPOINT}`,
        search: `?${createSearchParams([...searchParams.entries(), ["page", newPage]])}`,
      })
  };

  const handleChangeRowsPerPage = (e) => {
    window.scrollTo(0, 0)
    let value=parseInt(e.target.value, 10);
    if (rowsPerPage !== value) {
      searchParams.delete("pageLimit")
      searchParams.delete("page")
      navigate({
        pathname: `${STATUS_REPORT_ENDPOINT}`,
        search: `?${createSearchParams([...searchParams.entries(), ["pageLimit", value]])}`,
      })
    }
  };

  const handleProfileNavigation = (row)=>{
    let guestTypeID = 0;
    if (moment().isSameOrBefore(moment(row?.checkin_datetime))) guestTypeID = 0
    else if (moment().isSameOrAfter(moment(row?.checkout_datetime))) guestTypeID = 2
    else guestTypeID = 1

    const query = {filter_type: guestTypeID, phone_number: "", email: "", room_details:"", user_program_id: row.user_program_id, navigateToDetails: true}
    navigate(routes.SEARCH_RESULT_ENDPOINT, { state: query })
  }

  const handleIconNavigate = (path, row, box, ringNo)=>{
    let guestType = 'upcoming';
    if (moment().isSameOrBefore(moment(row?.check_in))) guestType = 'upcoming'
    else if (moment().isSameOrAfter(moment(row?.check_out))) guestType = 'completed'
    else guestType = 'active'


    let params ={
      guestId: row.user_id, 
      userProgramId: row.user_program_id, 
      user_id: row.user_id,
      type: guestType,
    }
    //query navigation
    if(path===routes.QUERY_ENDPOINT)
      navigate(`${path}/${row.user_id}`)
    //email navigation
    else if(path === routes.SEARCH_RESULT_ENDPOINT)
      handleProfileNavigation(row)
    //session review navigation
    else if(path===routes.VIEW_SESSION_ENDPOINT)
      navigate(`${path}?tab=2`, {state:{...params}})
    //health assessment
    else if(path===routes.VIEW_WELLBEING_REPORT_ENDPOINT){
      params ={
        ...params,
        is_self_assessment_enabled: row.is_self_assessment_enabled, 
        is_self_assessment_active: row.is_self_assessment_active,
        user_self_assessment_id: row?.[getHealthAssessmentIDKey({activityFilters, row})]
      }
      navigate(path, {state:{...params}})
    }
    //Consultation notes
    else if(path===routes.VIEW_CONSULTATION_NOTES_ENDPOINT){
      let newQueryData = [...searchParams.entries()].filter(item=>item[0]==="notesType")
      navigate({
        pathname: `${routes.VIEW_CONSULTATION_NOTES_ENDPOINT}`,
        search: `?${createSearchParams([...newQueryData])}`,
      }, {state:{...params}})
    }
    //other navigation
    else
      navigate(path, {state:{...params}})
  }


  const isSelected = (id, flatId) => selected.some(item => item.subscriberId === id && item.flatId === flatId);


  useEffect(()=>{      
    setSelected([])
  }, [searchParams])

  useEffect(()=>{
    setOrder(filter.order)
    setOrderBy(filter.orderBy)
  }, [filter])

  return (
    <Box
      sx={{ width: "100%", fontSize: "13px", paddingBottom: '10px' }}
      className="status-report-table-component"
    >
      <TableContainer
        sx={data.length || loading ? {minHeight: "500px"}: {}}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {!!checkbox && (
                <TableCellStyled size="small" sx={{pl:'0 !important', pr: 2, width: 36 }}>
                  <Checkbox
                    size="small"
                    indeterminate={false}
                    checked={data?.length > 0 && selected?.length === data?.length}
                    onChange={handleSelectAllClick}
                    inputProps={{
                      "aria-label": "select all",
                    }}
                    sx={{
                      p: 0,
                      color: "#AAAAA",
                      "&.Mui-checked": {
                        color: "#CF001C",
                      },
                    }}
                    disabled={loading || !data}
                  />
                </TableCellStyled>
              )}
              {columns?.map((column) => (
                <TableCellStyled
                  size="small"
                  key={column.sortingKey+ 'heading'}
                  align={column.numeric ? "right" : "left"}
                  sortDirection={orderBy === column.sortingKey ? order : false}
                  sx={{
                    width: column.width || "fit-content",
                    minWidth: column.width || "fit-content",
                  }}
                >
                  <TableSortLabel
                    hideSortIcon={true}
                    active={orderBy === column.sortingKey}
                    direction={orderBy === column.sortingKey ? order : "asc"}
                    onClick={() => {
                      if (column.sort) {
                        handleRequestSort(column.sortingKey);
                      }
                    }}
                    IconComponent={SortIcon}
                    sx={{
                      ".MuiTableSortLabel-icon": {
                        opacity: "1 !important",
                      },
                      svg: {
                        flexShrink: 0,
                      },
                    }}
                  >
                    {column.label}
                    {orderBy === column.sortingKey ? (
                      <Box component="span" sx={visuallyHidden}>
                        {order === "desc"
                          ? "sorted descending"
                          : "sorted ascending"}
                      </Box>
                    ) : null}
                  </TableSortLabel>
                </TableCellStyled>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {
                loading ?
                <TableRow >
                  <TableCellStyled sx={{border: 'none'}} colSpan={columns?.length+1}><div className='text-center mb-3'><CircularProgress size={35} sx={{'color': '#74613C'}}/></div></TableCellStyled>
                </TableRow>
                :
                <>
                  {!!data?.length && data?.map((row, rowIndex) => {
                      const isRowSelected = isSelected(row?.subscriberId, row.flatId);

                      return (
                        <React.Fragment 
                          key={`${rowIndex}`}
                        >
                          <TableRowStyled
                            role="checkbox"
                            aria-checked={isRowSelected}
                            tabIndex={-1}
                            selected={isRowSelected}
                          >
                            {!!checkbox && (
                              <TableCellStyled size="small" sx={{pl:'0 !important', zIndex: 0}} onClick={(event) => handleClick(event, row?.subscriberId, row?.flatId)}>
                                <Checkbox
                                  checked={isSelected(row?.subscriberId, row.flatId)}
                                  onChange={(e) =>handleClick(e, row?.subscriberId, row?.flatId)}
                                  size="small"
                                  color="primary"
                                  inputProps={{
                                    "aria-labelledby": `generic-table-checkbox-${row?.sortingKey}`,
                                  }}
                                  sx={{
                                    p: 0,
                                    color: "#AAAAA",
                                    "&.Mui-checked": {
                                      color: "#CF001C",
                                    },
                                  }}

                                />
                              </TableCellStyled>
                            )}
                            {/* Serial Number */}
                            <TableCellStyled className="fw-bold" size="small" align="left" style={{cursor: 'pointer'}} onClick={(event) => handleProfileNavigation(row)}>
                              { row.name}
                            </TableCellStyled>

                            <TableCellStyled size="small" align="left">
                              {row?.program}
                            </TableCellStyled>

                            <TableCellStyled size="small" align="left">
                              {row?.checkin_datetime ? moment(row?.checkin_datetime).format("MMM DD, YYYY") : '-'}
                            </TableCellStyled>

                            <TableCellStyled size="small" align="left">
                              {row?.checkout_datetime ? moment(row?.checkout_datetime).format("MMM DD, YYYY") : '-'}
                            </TableCellStyled>

                            <TableCellStyled size="small" align="left">
                              {row.roomNo}
                            </TableCellStyled>

                            <TableCellStyled size="small" align="left" >
                              {row?.doctor} 
                            </TableCellStyled>
                          </TableRowStyled>
                          <TableRowStyled>
                            <TableCellStyled colSpan={columns.length}>
                              <div className='d-flex justify-content-center justify-content-xl-between flex-wrap task-container mb-4 mx-2 text-break'>

                              { 
                                ITEMS.map((box, index)=>{
                                  let key = box.key({activityFilters, row})
                                  let dataKey = box?.dataKey?.({activityFilters, row})
                                  let idKey = box?.idKey?.({activityFilters, row})
                                  let restrictNavigation = !box.path || (row[key]?.toString()?.length==1 && parseInt(row[key]?.toString())==0 && !row[idKey])
                                  let ringNo = row[key]?.toString()?.length>1 ? 2 :  parseInt(row[key]?.toString() || 0)
                                    return(
                                      <React.Fragment key={index}>
                                        <div className="icon-box" >
                                            <div 
                                              className={`icon ${ restrictNavigation ? 'restrict' : ''} ${statusClasses[ringNo]}  ${ (box.permissions === "hide") ? 'restrict opacity-50' : ''}`}
                                              onClick={restrictNavigation || (box.permissions === "hide") ? undefined : ()=>{handleIconNavigate(box.path, row, box, ringNo)}} 
                                            >
                                                {box.image}
                                            </div>
                                            <div className={`title ${box.permissions === "hide" ? "opacity-50": ''}`}>{box.title}</div>
                                            <div className={` sub-title ${box.permissions === "hide" ? "opacity-50": ''} ${validateDate(row[dataKey]) ? '': 'fw-bold'}`}>{row[dataKey] && row[dataKey]?.length>1 ? row[dataKey] : '-'}</div>
                                        </div>
                                      </React.Fragment>
                                    )
                                })
                              }
                            </div>
                            </TableCellStyled>
                          </TableRowStyled>
                        </React.Fragment>
                      );
                    })}
                </>
              }
          </TableBody>
        </Table>
      </TableContainer>

      {!!pagination && data && (
        <div className="m-4">
          <TablePaginationStyled
            disabled={loading}
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={totalCount || 0}
            rowsPerPage={rowsPerPage || 10}
            page={currentPage || 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            SelectProps={{
              IconComponent: arrowDownIcon,
            }}
        />
        </div>
      )}
    </Box>
  );
};

StatusReportTable.propTypes = {
  columns: PropTypes.array.isRequired,
  defaultSortField: PropTypes.string,
  rowsPerPageOptions: PropTypes.array,
};

export default StatusReportTable;